// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"102":"52f33b86","107":"ed914e7a","137":"6f1703db","167":"885836ef","177":"048c5100","267":"8f93a19c","372":"430cd4fa","567":"04803fd6","734":"8107375c","806":"14d8990e","814":"f473716b"}[chunkId] + ".js";
};